
import { Vue } from "vue-class-component";

export default class Ship extends Vue {}
